/* joacă bună — wishlist (localStorage, fără cont, fără aplicație).
   Cheie: jb_wishlist = JSON array de HANDLE-uri produs. */
(function () {
  'use strict';
  var KEY = 'jb_wishlist';
  var config = {};
  var configNode = document.querySelector('[data-wishlist-config]');
  if (configNode) {
    try { config = JSON.parse(configNode.textContent); } catch (e) { config = {}; }
  }
  var productBase = config.productBase || 'products/';

  function get() {
    try {
      var raw = localStorage.getItem(KEY);
      var arr = raw ? JSON.parse(raw) : [];
      return Array.isArray(arr) ? arr.filter(function (h) { return typeof h === 'string' && h; }) : [];
    } catch (e) { return []; }
  }
  function save(arr) {
    try { localStorage.setItem(KEY, JSON.stringify(arr)); } catch (e) {}
  }
  function has(handle) { return get().indexOf(handle) !== -1; }
  function count() { return get().length; }
  function toggle(handle) {
    if (!handle) return false;
    var arr = get();
    var i = arr.indexOf(handle);
    var saved;
    if (i === -1) { arr.push(handle); saved = true; }
    else { arr.splice(i, 1); saved = false; }
    save(arr);
    return saved;
  }

  function cuSeparatoare(cents, zecimale, mii, zecimal) {
    var valoare = (cents / 100).toFixed(zecimale);
    var parti = valoare.split('.');
    parti[0] = parti[0].replace(/\B(?=(\d{3})+(?!\d))/g, mii);
    return zecimale ? parti[0] + zecimal + parti[1] : parti[0];
  }
  function fmtMoney(cents) {
    var format = config.moneyFormat || '{{amount}}';
    var reper = format.match(/\{\{\s*(\w+)\s*\}\}/);
    if (!reper) return String(cents / 100);
    var valoare;
    switch (reper[1]) {
      case 'amount_no_decimals': valoare = cuSeparatoare(cents, 0, ',', '.'); break;
      case 'amount_with_comma_separator': valoare = cuSeparatoare(cents, 2, '.', ','); break;
      case 'amount_no_decimals_with_comma_separator': valoare = cuSeparatoare(cents, 0, '.', ','); break;
      case 'amount_with_apostrophe_separator': valoare = cuSeparatoare(cents, 2, "'", '.'); break;
      default: valoare = cuSeparatoare(cents, 2, ',', '.');
    }
    return format.replace(reper[0], valoare);
  }

  /* —— sincronizare UI —— */
  function syncCounters() {
    var n = count();
    var nodes = document.querySelectorAll('[data-wishlist-count]');
    for (var i = 0; i < nodes.length; i++) {
      nodes[i].textContent = n;
      if (n > 0) { nodes[i].removeAttribute('hidden'); }
      else { nodes[i].setAttribute('hidden', ''); }
    }
  }
  function markToggle(el) {
    var saved = has(el.getAttribute('data-handle'));
    el.classList.toggle('is-saved', saved);
    el.setAttribute('aria-pressed', saved ? 'true' : 'false');
    var saveLabel = el.getAttribute('data-label-save') || config.saveLabel || '';
    var removeLabel = el.getAttribute('data-label-remove') || config.removeLabel || '';
    el.setAttribute('aria-label', saved ? removeLabel : saveLabel);
  }
  function syncToggles() {
    var nodes = document.querySelectorAll('[data-wishlist-toggle]');
    for (var i = 0; i < nodes.length; i++) { markToggle(nodes[i]); }
  }

  function onToggleClick(e) {
    var el = e.target.closest('[data-wishlist-toggle]');
    if (!el) return;
    if (el.tagName === 'A' || el.closest('a')) { e.preventDefault(); }
    e.stopPropagation();
    toggle(el.getAttribute('data-handle'));
    /* actualizează toate butoanele cu același handle (card + PDP) */
    var same = document.querySelectorAll('[data-wishlist-toggle][data-handle="' + el.getAttribute('data-handle') + '"]');
    for (var i = 0; i < same.length; i++) { markToggle(same[i]); }
    syncCounters();
    renderGridItem(el.getAttribute('data-handle')); // dacă suntem pe pagina wishlist
  }

  /* —— pagina wishlist ——
     Cardul construit aici oglindește EXACT `snippets/jb-card-produs.liquid`:
     <article class="produs press"> → <a class="produs__link"> → .poza + .jos (h3, p.pret).
     Butonul de salvare stă în article, în AFARA linkului — link în link nu e HTML valid
     și nici navigabil de la tastatură. Aceleași clase ca pe grila randată de Liquid,
     deci zero CSS propriu paginii de favorite.
     `.varsta` și `.epuizat` lipsesc deliberat: vin din tag-uri și din disponibilitate,
     iar `/products/x.js` nu le dă în forma în care le formatează snippetul. Slot absent,
     nu slot inventat. */
  function buildCard(prod) {
    var img = (prod.featured_image || (prod.images && prod.images[0]) || '');
    if (img && img.indexOf('//') === 0) { img = 'https:' + img; }
    var li = document.createElement('li');
    li.setAttribute('data-wishlist-item', prod.handle);
    var url = productBase + encodeURIComponent(prod.handle);
    var secondary = (prod.images || [])[1] || '';
    if (secondary && secondary.indexOf('//') === 0) { secondary = 'https:' + secondary; }
    var media = img
      ? '<img class="produs__imagine--principala" src="' + escapeAttr(img) + '" alt="' + escapeAttr(prod.title) + '" loading="lazy">'
      : '';
    if (img && secondary) {
      media += '<picture class="produs__imagine--secundara" aria-hidden="true">' +
        '<source media="(hover: hover) and (pointer: fine)" srcset="' + escapeAttr(secondary) + '">' +
        '<img src="data:image/svg+xml,%3Csvg xmlns=\'http://www.w3.org/2000/svg\' width=\'1\' height=\'1\'/%3E" alt="" loading="lazy" decoding="async" fetchpriority="low" data-card-secondary>' +
        '</picture>';
    }
    li.innerHTML =
      '<article class="produs press">' +
        '<a href="' + escapeAttr(url) + '" class="produs__link">' +
          '<div class="poza">' + media + '</div>' +
          '<div class="jos">' +
            '<h3>' + escapeHtml(prod.title) + '</h3>' +
            '<p class="pret">' + fmtMoney(prod.price) + '</p>' +
          '</div>' +
        '</a>' +
        '<button type="button" class="produs__salveaza press is-saved" data-wishlist-toggle' +
          ' data-handle="' + escapeAttr(prod.handle) + '" aria-pressed="true"' +
          ' data-label-save="' + escapeAttr(config.saveLabel || '') + '"' +
          ' data-label-remove="' + escapeAttr(config.removeLabel || '') + '"' +
          ' aria-label="' + escapeAttr(config.removeLabel || '') + '">' + heartSvg() + '</button>' +
      '</article>';
    return li;
  }
  function escapeHtml(s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }
  function escapeAttr(s) { return escapeHtml(s); }
  /* Identică cu `{%- render 'jb-icon', icon: 'inima' -%}`: același path Lucide, aceeași
     clasă `i i--24`. Fără atribute inline de fill/stroke — le dă `.i` din jb-sistem.css,
     inclusiv grosimea compensată optic pe mărime. O inimă cu stroke-width scris de mână
     ar ieși mai groasă decât toate celelalte iconițe de pe pagină. */
  function heartSvg() {
    return '<svg class="i i--24" viewBox="0 0 24 24" aria-hidden="true"><path d="M2 9.5a5.5 5.5 0 0 1 9.591-3.676.56.56 0 0 0 .818 0A5.49 5.49 0 0 1 22 9.5c0 2.29-1.5 4-3 5.5l-5.492 5.313a2 2 0 0 1-3 .019L5 15c-1.5-1.5-3-3.2-3-5.5"/></svg>';
  }

  function renderGridItem(handle) {
    var grid = document.querySelector('[data-wishlist-grid]');
    if (!grid) return;
    /* dacă handle-ul nu mai e salvat, scoate cardul existent */
    if (!has(handle)) {
      var ex = grid.querySelector('[data-wishlist-item="' + handle + '"]');
      if (ex) { ex.parentNode.removeChild(ex); }
    }
    updateGridEmpty();
  }
  function updateGridEmpty() {
    var grid = document.querySelector('[data-wishlist-grid]');
    if (!grid) return;
    var empty = document.querySelector('[data-wishlist-empty]');
    var hasCards = grid.querySelector('[data-wishlist-item]');
    if (empty) { if (hasCards) { empty.setAttribute('hidden', ''); } else { empty.removeAttribute('hidden'); } }
  }

  function renderGrid() {
    var grid = document.querySelector('[data-wishlist-grid]');
    if (!grid) return;
    var handles = get();
    grid.innerHTML = '';
    if (!handles.length) { updateGridEmpty(); return; }
    handles.forEach(function (handle) {
      fetch(productBase + encodeURIComponent(handle) + '.js', { headers: { 'Accept': 'application/json' } })
        .then(function (r) { return r.ok ? r.json() : null; })
        .then(function (prod) {
          if (!prod || !prod.handle) return; // produs lipsă/șters — ignoră elegant
          /* nu re-adăuga dacă a fost eliminat între timp */
          if (!has(prod.handle)) return;
          if (grid.querySelector('[data-wishlist-item="' + prod.handle + '"]')) return;
          grid.appendChild(buildCard(prod));
          syncToggles();
          updateGridEmpty();
        })
        .catch(function () {})
        .then(function () { updateGridEmpty(); });
    });
  }

  function init() {
    syncToggles();
    syncCounters();
    renderGrid();
    document.addEventListener('click', onToggleClick);
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else { init(); }

  window.JBWishlist = { get: get, has: has, toggle: toggle, count: count };
})();
